import React from "react";
import Card from "components/card";

const ActivityCard = ({
    title,
    date,
    points,
}) => {
    return (
        <Card className="flex items-center justify-between p-3 border border-slate-200 rounded-xl">
            <div>
                <p className="text-sm font-medium">{title}</p>
                <p className="text-xs text-slate-700">{date}</p>
            </div>
            <span 
                className=" inline-flex items-center justify-center rounded-lg border px-2 py-0.5 
                text-xs font-medium w-fit whitespace-nowrap shrink-0 
                transition-[color,box-shadow] overflow-hidden border-transparent bg-purple-100 text-purple-700
            ">
                {points}
            </span>
        </Card>
    )
};
export default ActivityCard;